import React, { Fragment } from 'react'

import { Helmet } from 'react-helmet'

import Navbar from '../components/navbar'
import Footer from '../components/footer'
import './who-can-benefit.css'

const WhoCanBenefit = (props) => {
  return (
    <div className="who-can-benefit-container1">
      <Helmet>
        <title>WhoCanBenefit - Copy of iCharge web copy 2</title>
        <meta
          property="og:title"
          content="WhoCanBenefit - Copy of iCharge web copy 2"
        />
        <meta
          property="og:image"
          content="https://aheioqhobo.cloudimg.io/v7/_playground-bucket-v2.teleporthq.io_/d8d38ac4-4f3e-47be-9087-cfeb299d0f93/a5b67eda-b5fa-4da5-98e7-80a54823e21a?org_if_sml=1&amp;force_format=original"
        />
      </Helmet>
      <Navbar
        homeLink1={
          <Fragment>
            <span className="who-can-benefit-text10">
              View real-time charger availability, monitor your charging
              sessions, and more
            </span>
          </Fragment>
        }
        homeLink2={
          <Fragment>
            <span className="who-can-benefit-text11">
              Discover one of the nation&apos;s largest public fast charging
              networks, powered by 100% renewable energy
            </span>
          </Fragment>
        }
        homeLink3={
          <Fragment>
            <span className="who-can-benefit-text12">How to Charge</span>
          </Fragment>
        }
        homeLink4={
          <Fragment>
            <span className="who-can-benefit-text13">
              Learn how to power up on the go and review our charging FAQs.
            </span>
          </Fragment>
        }
        homeLink5={
          <Fragment>
            <span className="who-can-benefit-text14">
              Can&apos;t find what you&apos;re looking for? Let us help you.
            </span>
          </Fragment>
        }
        aboutLink1={
          <Fragment>
            <span className="who-can-benefit-text15">
              From recycling to renewable energy, we&apos;re committed to
              protecting our environment.
            </span>
          </Fragment>
        }
        aboutLink2={
          <Fragment>
            <span className="who-can-benefit-text16">
              Cultivating Connection
            </span>
          </Fragment>
        }
        supportLink1={
          <Fragment>
            <span className="who-can-benefit-text17">
              <span>
                Whether you&apos;re a dedicated public charger or want to keep
                your options open,
              </span>
              <br></br>
              <span> iCharge has a plan for you.</span>
            </span>
          </Fragment>
        }
        supportLink2={
          <Fragment>
            <span className="who-can-benefit-text21">How to charge</span>
          </Fragment>
        }
        rootClassName="navbarroot-class-name9"
        chargingPointLink1={
          <Fragment>
            <span className="who-can-benefit-text22">
              Can&apos;t find what you&apos;re looking for? Let us help you
            </span>
          </Fragment>
        }
        chargingPointLink2={
          <Fragment>
            <span className="who-can-benefit-text23">
              Locate nearby charging points with the iCharge app and simplify
              your charging
            </span>
          </Fragment>
        }
      ></Navbar>
      <main className="who-can-benefit-main column align-center full-vertical-height justify-center full-width">
        <h1 className="who-can-benefit-text24 heading-1">Who Can Benefit</h1>
        <section className="who-can-benefit-service1 column align-center justify-center full-width thq-section-padding">
          <div className="who-can-benefit-max-width1 row full-width max-content-width">
            <div className="who-can-benefit-content1 column gap-5">
              <div className="column gap-5">
                <h2 className="who-can-benefit-text25 heading-2">
                  Business Fleets
                </h2>
                <p className="who-can-benefit-text26 sub-heading-2">
                  <span>
                    <span
                      dangerouslySetInnerHTML={{
                        __html: ' ',
                      }}
                    />
                  </span>
                  <span className="who-can-benefit-text28">
                    Efficiently manage fleet charging, monitor usage, and reduce
                    operational costs via a centralized dashboard.
                  </span>
                </p>
              </div>
            </div>
            <div className="who-can-benefit-container3">
              <img
                alt="pastedImage"
                sizes="(min-width: 992px) 1200px, (min-width: 768px) 800px, 480px"
                src="/external/taxi1-1500w.webp"
                srcSet="/external//taxi1-1500w.webp 1200w, /external/taxi1-tablet.webp 800w, /external/taxi1-mobile.webp 480w"
                className="who-can-benefit-pasted-image1"
              />
            </div>
          </div>
        </section>
        <section className="who-can-benefit-service2 column align-center justify-center full-width thq-section-padding">
          <div className="who-can-benefit-max-width2 row full-width max-content-width">
            <div className="who-can-benefit-content2 column gap-5">
              <div className="column gap-5">
                <h2 className="who-can-benefit-text29 heading-2">
                  Restaurants, Malls, and High-Traffic Venues
                </h2>
                <p className="who-can-benefit-text30 sub-heading-2">
                  Offer charging while customers stay and stay ahead of
                  competitors.
                </p>
              </div>
            </div>
            <div className="who-can-benefit-container5">
              <img
                alt="pastedImage"
                sizes="(min-width: 992px) 1200px, (min-width: 768px) 800px, 480px"
                src="/external/width_1600-1500w.webp"
                srcSet="/external//width_1600-1500w.webp 1200w, /external/width_1600-tablet.webp 800w, /external/width_1600-mobile.webp 480w"
                className="who-can-benefit-pasted-image2"
              />
            </div>
          </div>
        </section>
        <section className="who-can-benefit-service3 column align-center justify-center full-width thq-section-padding">
          <div className="who-can-benefit-max-width3 row full-width max-content-width">
            <div className="who-can-benefit-content3 column gap-5">
              <div className="column gap-5">
                <h2 className="who-can-benefit-text31 heading-2">
                  Hotels &amp; Resorts
                </h2>
                <p className="who-can-benefit-text32 sub-heading-2">
                  Attract clients with EV charging as part of premium services
                  and generate extra revenue.
                </p>
              </div>
            </div>
            <div className="who-can-benefit-container7">
              <img
                alt="pastedImage"
                sizes="(min-width: 992px) 1200px, (min-width: 768px) 800px, 480px"
                src="/external/width_1024-1500w.webp"
                srcSet="/external//width_1024-1500w.webp 1200w, /external/width_1024-tablet.webp 800w, /external/width_1024-mobile.webp 480w"
                className="who-can-benefit-pasted-image3"
              />
            </div>
          </div>
        </section>
        <section className="who-can-benefit-service4 column align-center justify-center full-width thq-section-padding">
          <div className="who-can-benefit-max-width4 row full-width max-content-width">
            <div className="who-can-benefit-content4 column gap-5">
              <div className="column gap-5">
                <h2 className="who-can-benefit-text33 heading-2">
                  Public Organizations &amp; Institutions
                </h2>
                <p className="who-can-benefit-text34 sub-heading-2">
                  Promote sustainable transport and contribute to reducing
                  pollution and improving urban infrastructure.
                </p>
              </div>
            </div>
            <div className="who-can-benefit-container9">
              <img
                alt="pastedImage"
                sizes="(min-width: 992px) 1200px, (min-width: 768px) 800px, 480px"
                src="/external/width_1024%20(1)-1500w.webp"
                srcSet="/external//width_1024%20(1)-1500w.webp 1200w, /external/width_1024%20(1)-tablet.webp 800w, /external/width_1024%20(1)-mobile.webp 480w"
                className="who-can-benefit-pasted-image4"
              />
            </div>
          </div>
        </section>
      </main>
      <Footer rootClassName="footerroot-class-name10"></Footer>
    </div>
  )
}

export default WhoCanBenefit
